module.exports = __webpack_public_path__ + "static/media/Oud-Brabant.3afef6bc.jpg";